import { Notification } from '../models/notification.interfaces';

export const ElementMocks = document.createElement('div');
ElementMocks.id = 'mockElement';
ElementMocks.className = 'notification';

export const NotificationSuccessMocks: Notification = {
  type: 'success',
  message: 'Your information has been successfully saved.'
};

export const NotificationErrorMocks: Notification = {
  type: 'error',
  message: 'To continue, please correct the ',
  errors: '6 items indicated.',
  focusItem: ElementMocks
};

export const ErrorDetailsMocks: Error = {
  message: 'Element not found: nonExistentId',
  name: '[UI Error]',
  stack: 'String: nonExistentId'
};

export const NotificationErrorNoElementMocks: Notification = {
  type: 'error',
  message: 'To continue, please correct the ',
  errors: '6 items indicated.',
  focusItem: null
};

export const IconMocks = {
  id: 'success',
  disabled: false,
  width: '18.75px',
  height: '18.75px',
  alt: 'success icon',
  src: '/content/dam/delta-applications/ui-kit/assets/svg/alerts/success-icon.svg'
};

export const IntersectEntryMocks: IntersectionObserverEntry[] = [
  {
    isIntersecting: false,
    target: ElementMocks,
    boundingClientRect: {} as DOMRectReadOnly,
    intersectionRatio: 0,
    intersectionRect: {} as DOMRectReadOnly,
    rootBounds: {} as DOMRectReadOnly | null,
    time: 0
  }
];
